// extracted by mini-css-extract-plugin
module.exports = {"open":"JobPage_open__2VAQW","closed":"JobPage_closed__32lmy"};